<template>
  <PageContainer type="bg2">
    <section class="address">
      <div class="address__header">
        <p>
          <img :src="LocationImage">
          地址管理
        </p>
        <button :disabled="addresses.length >=5" @click="handleOpenModal()">
          <img :src="AddImage">
          新增地址
        </button>
      </div>
      <div class="address__container">
        <div v-for="address in addresses" :key="address.id" class="address__content">
          <div class="address__text">
            <p>{{ address.receiverName }} {{ address.receiverTel }}</p>
            <p>{{ address.province }}{{ address.city }}（{{ address.postCode }}）{{ address.district }}{{ address.address }}</p>
          </div>
          <div class="address__action">
            <button class="default-button" :disabled="address.default" @click="handleSetDefaultAddress(address.id)">
              <img :src="CheckImage">
              預設地址
            </button>
            <button class="edit-button" @click="handleOpenModal(address)">
              <img :src="PenImage">
              編輯地址
            </button>
            <button @click="handleDeleteAddress(address.id)">
              <img :src="DeleteImage">
              刪除地址
            </button>
          </div>
        </div>
        <CreateEditModal :visible="visible" :is-edit="isEdit" :data-source="dataSource" @onClose="handleCloseModal()" @onSubmit="handleSubmit" />
      </div>
    </section>
  </PageContainer>
</template>

<script>
import LocationImage from '@/assets/img/address/location.png'
import AddImage from '@/assets/img/address/add.png'
import CheckImage from '@/assets/img/address/check.png'
import PenImage from '@/assets/img/address/pen.png'
import DeleteImage from '@/assets/img/address/del.png'
import { mapActions, mapGetters } from 'vuex'
import api from '@/api'
import CreateEditModal from './CreateEditModal.vue'
import PageContainer from '@/components/PageContainer'

export default {
  components: {
    PageContainer,
    CreateEditModal
  },
  data() {
    return {
      LocationImage,
      AddImage,
      CheckImage,
      PenImage,
      DeleteImage,
      visible: false,
      isEdit: false,
      dataSource: {}
    }
  },
  computed: {
    ...mapGetters(['addresses'])
  },
  mounted() {
    this.getAddresses()
  },
  methods: {
    ...mapActions(['getAddresses']),
    handleOpenModal(dataSource) {
      console.log(dataSource)
      this.isEdit = !!dataSource
      this.dataSource = dataSource || {}
      this.visible = true
    },
    handleCloseModal() {
      this.isEdit = false
      this.dataSource = {}
      this.visible = false
    },
    handleMessage(message, type = 'success') {
      this.$message({
        type,
        message,
        duration: 1500
      })
    },
    async handleSubmit(data) {
      if (this.isEdit) {
        this.handleUpdate(data)
      } else {
        this.handleCreate(data)
      }
    },
    async handleCreate(data) {
      try {
        const { success } = await api.address.createAddress(data) || {}
        if (success) {
          this.getAddresses()
          this.handleMessage('新增成功')
          this.handleCloseModal()
        }
      } catch (err) {
        console.log(err)
      }
    },
    async handleUpdate(data) {
      const { id } = this.dataSource

      try {
        const { success } = await api.address.updateAddress(id, data) || {}
        if (success) {
          this.getAddresses()
          this.handleMessage('編輯成功')
          this.handleCloseModal()
        }
      } catch (err) {
        console.log(err)
      }
    },
    async handleSetDefaultAddress(id) {
      try {
        const { success } = await api.address.setDefaultAddress(id) || {}
        if (success) {
          this.getAddresses()
          this.handleMessage('設定成功')
        }
      } catch (err) {
        console.log(err)
      }
    },
    handleDeleteAddress(id) {
      this.$confirm('確認刪除此地址？', '提示', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        try {
          const { success } = await api.address.deleteAddress({ id }) || {}
          if (success) {
            this.getAddresses()
            this.handleMessage('刪除成功')
          }
        } catch (err) {
          console.log(err)
        }
      }).catch(() => {
        this.handleMessage('已取消删除', 'info')
      })
    }
  }
}
</script>

<style scoped lang="scss">
.address {
  &__header,&__content, &__action {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
  }

  &__content {
    flex-direction: column;
    align-items: flex-start;
    .el-button+.el-button {
      margin-left: 2px;
    }
    @include minWidth768 {
      .el-button+.el-button {
        margin-left: 10px;
      }
      align-items: center;
      flex-direction: row;
      justify-content: space-between;
    }
  }
}

.address {
  width: 100%;
  p {
    margin: 0;
  }
  &__header {
    padding-bottom: 10px;
    margin-bottom: 10px;
    border-bottom: 1px solid #9a9a9a;
    > p {
      font-size: 24px;
    }
  }
  &__content {
    margin-bottom: 10px;
  }
  &__text {
    color: $mainPurple;
    > p:last-child {
      color: #9a9a9a;
    }
  }
}

button {
  background-color: transparent;
  border: 0;
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  font-size: 16px;
  img {
    width: 20px;
    height: 20px;
    object-fit: contain;
  }
  &.default-button {
    color: #fd9e5b;
    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
  &.edit-button {
    color: #5eae0e;
  }
}
</style>
